module.exports = __webpack_public_path__ + "static/media/sprite.0e3d8a89.svg";